import { render, staticRenderFns } from "./orderTaskReject.vue?vue&type=template&id=3872fa8f&scoped=true"
import script from "./orderTaskReject.vue?vue&type=script&lang=js"
export * from "./orderTaskReject.vue?vue&type=script&lang=js"
import style0 from "./orderTaskReject.vue?vue&type=style&index=0&id=3872fa8f&prod&lang=scss"
import style1 from "./orderTaskReject.vue?vue&type=style&index=1&id=3872fa8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3872fa8f",
  null
  
)

export default component.exports